<template>
  <div class="card organization-card">
    <div class="card__section">
      <h1 class="organization-name">
        {{ (organization.name && organization.name.trim()) || 'Unnamed Organization' }}
      </h1>
      <h5 class="org-name text-blue text-upper text-small">
        <span class="text-small">Grant Configuration</span>
      </h5>
      <div class="OrganizationCard__ConfigEntry">
        <span class="OrganizationCard__ConfigKey">
          Grant Limit:
        </span>
        <span class="OrganizationCard__ConfigValue">
          {{ organization.grantLimit }}
        </span>
      </div>
      <div class="OrganizationCard__ConfigEntry" v-if="organization.grantLimitLifetime">
        <span class="OrganizationCard__ConfigKey">
          Grant Limit (Lifetime):
        </span>
        <span class="OrganizationCard__ConfigValue">
          {{ organization.grantLimitLifetime }}
        </span>
      </div>
      <div class="OrganizationCard__ConfigEntry">
        <span class="OrganizationCard__ConfigKey">
          Grant Limit Duration:
        </span>
        <span class="OrganizationCard__ConfigValue">
          {{ organization.grantLimitDuration }}
        </span>
      </div>
      <div class="OrganizationCard__ConfigEntry">
        <span class="OrganizationCard__ConfigKey">
          Rolling Grant Duration:
        </span>
        <span class="OrganizationCard__ConfigValue">
          {{ organization.rollingGrantDuration }}
        </span>
      </div>
      <div class="OrganizationCard__ConfigEntry">
        <span class="OrganizationCard__ConfigKey">
          Grant Count Limit:
        </span>
        <span class="OrganizationCard__ConfigValue">
          {{ organization.grantCountLimit }}
        </span>
      </div>
      <div class="OrganizationCard__ConfigEntry">
        <span class="OrganizationCard__ConfigKey">
          Force Single Event:
        </span>
        <span class="OrganizationCard__ConfigValue">
          {{ organization.selectOneEvent ? 'YES' : 'NO' }}
        </span>
      </div>
      <div class="OrganizationCard__ConfigEntry">
        <span class="OrganizationCard__ConfigKey">
          Enable When it Happened:
        </span>
        <span class="OrganizationCard__ConfigValue">
          {{ organization.enableWhenItHappenedEventQuestion ? 'YES' : 'NO' }}
        </span>
      </div>
      <div class="OrganizationCard__ConfigEntry">
        <span class="OrganizationCard__ConfigKey">
          Enable Event Docs:
        </span>
        <span class="OrganizationCard__ConfigValue">
          {{ organization.eventDocumentationEnabled ? 'YES' : 'NO' }}
        </span>
      </div>
      <div class="OrganizationCard__ConfigEntry">
        <span class="OrganizationCard__ConfigKey">
          Enable Expense Docs:
        </span>
        <span class="OrganizationCard__ConfigValue">
          {{ organization.expenseDocumentationEnabled ? 'YES' : 'NO' }}
        </span>
      </div>
      <div class="OrganizationCard__ConfigEntry">
        <span class="OrganizationCard__ConfigKey">
          Request Amount Enabled:
        </span>
        <span class="OrganizationCard__ConfigValue">
          {{ organization.grantRequestAmountEnabled ? 'YES' : 'NO' }}
        </span>
      </div>
      <div class="OrganizationCard__ConfigEntry">
        <span class="OrganizationCard__ConfigKey">
          Request Amt is Grant Limit:
        </span>
        <span class="OrganizationCard__ConfigValue">
          {{ organization.grantRequestAmountIsGrantLimit ? 'YES' : 'NO' }}
        </span>
      </div>
    </div>

    <div v-if="report" class="card__section card__section--bordered">
      <h5 class="text-blue text-upper text-small">
        {{ organization.name.trim() || $gettext('Unnamed Organization') }}'s {{ $gettext('HISTORY') }}
      </h5>
      <div class="OrganizationCard__ConfigEntry">
        <span class="OrganizationCard__ConfigKey">
          Amount Contributed:
        </span>
        <span class="OrganizationCard__ConfigValue">
          {{ report.amountContributed }}
        </span>
      </div>
      <div class="OrganizationCard__ConfigEntry">
        <span class="OrganizationCard__ConfigKey">
          Amount Disbursed:
        </span>
        <span class="OrganizationCard__ConfigValue">
          {{ report.amountDisbursed }}
        </span>
      </div>
      <div class="OrganizationCard__ConfigEntry">
        <span class="OrganizationCard__ConfigKey">
          Eligible Users:
        </span>
        <span class="OrganizationCard__ConfigValue">
          {{ report.eligibleUsers }}
        </span>
      </div>
      <div class="OrganizationCard__ConfigEntry">
        <span class="OrganizationCard__ConfigKey">
          Median Recurring Payroll Contribution:
        </span>
        <span class="OrganizationCard__ConfigValue">
          {{ report.medianRecurringPayrollContributions }}
        </span>
      </div>
      <div class="OrganizationCard__ConfigEntry">
        <span class="OrganizationCard__ConfigKey">
          Median One Time Card Contribution:
        </span>
        <span class="OrganizationCard__ConfigValue">
          {{ report.medianOneTimeCardContribution }}
        </span>
      </div>
      <div class="OrganizationCard__ConfigEntry">
        <span class="OrganizationCard__ConfigKey">
          Requests Fully Approved:
        </span>
        <span class="OrganizationCard__ConfigValue">
          {{ report.requestsFullyApproved }}
        </span>
      </div>
      <div class="OrganizationCard__ConfigEntry">
        <span class="OrganizationCard__ConfigKey">
          Requests Partially Approved:
        </span>
        <span class="OrganizationCard__ConfigValue">
          {{ report.requestsPartiallyApproved }}
        </span>
      </div>
      <div class="OrganizationCard__ConfigEntry">
        <span class="OrganizationCard__ConfigKey">
          Requests Declined:
        </span>
        <span class="OrganizationCard__ConfigValue">
          {{ report.requestsDeclined }}
        </span>
      </div>
      <div class="OrganizationCard__ConfigEntry">
        <span class="OrganizationCard__ConfigKey">
          Unique Contributors
        </span>
        <span class="OrganizationCard__ConfigValue">
          {{ report.uniqueContributors }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { customVariableValue } from '../../services/organizationCustomVariables'
import { mapState } from 'vuex'

export default {
  name: 'organizationCard',
  props: {
    organization: {
      type: Object,
      required: true,
    },
    report: {
      type: Object,
      required: false,
    },
  },
  methods: {
    payoutOptions() {
      if (this.organization.paypalEmail && !this.organization.wiseAccountId) {
          return 'PayPal'
      }
      if (!this.organization.paypalEmail && this.organization.wiseAccountId) {
          return 'Wise'
      }
      if (this.organization.paypalEmail && this.organization.wiseAccountId) {
          return 'Wise & PayPal'
      }

      'Other, please check this account'
    },
    formatGrantLimitDuration(duration, rollingGrantDuration) {
      const lookup = {
        CALENDAR_YEAR: 'Calendar Year',
        LIFETIME: 'Lifetime',
        ROLLING_X_YEARS: `Rolling ${rollingGrantDuration} Years`,
      }
      return lookup[duration]
    },
    eventNames() {
        return this.organization.eventNames
    },
  },
  computed: {
    ...mapState(['organizationDetails']),
    orgDocumentationSettings() {
      if (
        !this.organization.expenseDocumentationEnabled &&
        !this.organization.eventDocumentationEnabled
      ) {
        return 'None'
      }
      if (
        this.organization.expenseDocumentationEnabled &&
        !this.organization.eventDocumentationEnabled
      ) {
        return 'Expense only'
      }
      if (
        !this.organization.expenseDocumentationEnabled &&
        this.organization.eventDocumentationEnabled
      ) {
        return 'Event only'
      }
      if (
        this.organization.expenseDocumentationEnabled &&
        this.organization.eventDocumentationEnabled
      ) {
        return 'Event & Expense'
      }

      return 'Event & Expense'
    },
    customVariablesEight() {
      return customVariableValue('{{cv8}}', this.organization.customVariables || {})
    },
    channel() {
      let channel = 'Email'
      if (this.organization.enableSmsAlerts && this.organization.validatedNumber) {
        channel = 'SMS'
      }
      if (
        this.organization.enableSmsAlerts &&
        this.organization.validatedNumber &&
        this.organization.enableEmailAlerts
      ) {
        channel = 'Email & SMS'
      }
      return channel
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../styles/variables';
@import '../../styles/mixins/cards';

.card {
  @include card;
}

.organization-card {
  flex: 5;
  align-self: flex-start;
  max-width: .333vw;

  @media (min-width: $mobile-break-point) {
    min-width: 24rem;
  }
}

.org-name {
  line-height: 0.65rem;
}
.sub-org {
  font-size: 0.65rem;
  opacity: 0.75;
}

.asterisk {
  color: $ruby;
}

.organization-name {
  text-align: left;
  cursor: pointer;
}

.OrganizationCard__ConfigEntry {
  display: flex;
}

.OrganizationCard__ConfigKey {
  font-weight: light;
  margin-right: 0.75em;
}

.OrganizationCard__ConfigValue {
  font-weight: bold;
}

.OrganizationCard__ConfigSection__Heading {
  font-size: 17px;
}

</style>
